import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../services/media-query.service';
import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'td-wb-filter-button',
  templateUrl: 'filter-button.component.html',
  styleUrls: ['filter-button.component.scss'],
  imports: [
    AsyncPipe,
    ButtonComponent,
    TranslatePipe,
    TranslateDirective,
    IconComponent,
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterButtonComponent implements OnInit {
  @Input() numberOfFilter: number;
  @Output() readonly show: EventEmitter<void> = new EventEmitter<void>();

  breakpointChanges$: Observable<BreakpointState>;

  constructor(private mediaQueryService: MediaQueryService) {
  }

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.SM);
  }

  hasFilter(): boolean {
    return this.numberOfFilter !== undefined && this.numberOfFilter > 0;
  }

  showFilters(): void {
    this.show.emit();
  }
}
